module.exports = __webpack_public_path__ + "static/media/icon-play.c0e188f7.svg";